import React, { ComponentProps } from 'react';
import Div from '../../Element/Div/Div';
import style from '../CollapsibleBlock.module.scss';

type CollapsibleBlockListProps = {
  children: NonNullable<React.ReactNode>;
} & ComponentProps<typeof Div>;

const CollapsibleBlockList: React.FunctionComponent<CollapsibleBlockListProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <Div className={[className, style.collapsibleBlockList]} {...props}>
      {children}
    </Div>
  );
};

export default CollapsibleBlockList;
